<div class="enfaf-input-file-dragger-dark" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)" [class.dragover]="isDraggingOver">
  <div class="dropzone-area" (click)="triggerFileInput()">
    <div class="content">
      @if (isUploadingFile) {
      <div class="loader-overlay">
        <div class="loader"></div>
      </div>
      } @else {
      <div class="content-header">
        <app-enfaf-icon class="upload-cloud" svgIconName="upload-cloud" iconSize="56px"
          color="#FFFFFF"></app-enfaf-icon>
        <div class="text">
          {{ title }}
          <br />
          {{ subtitle }}
        </div>
      </div>
      <app-enfaf-button class="upload-button" type="dark-blue" height="41px"
        [setNgStyle]="{ 'font-size': '14px', 'max-height': '41px' }">{{ buttonText
        }}</app-enfaf-button>
      }
    </div>
  </div>

  <div class="files-list">
    @if (files.length > 0 || currentFiles.length > 0) {
    <div class="files-content">
      @for (file of files; track file; let i = $index) {
      <ng-container
        *ngTemplateOutlet="fileItem; context: { $implicit: file, index: i, isCurrentFile: false }"></ng-container>
      }
      @for (file of currentFiles; track file.filename; let i = $index) {
      <ng-container
        *ngTemplateOutlet="fileItem; context: { $implicit: file, index: i, isCurrentFile: true }"></ng-container>
      }
    </div>
    } @else {
    <div class="no-files">
      <div class="content-header">
        <app-enfaf-icon class="no-files-icon" svgIconName="file-dark" iconSize="56px" color="#FFFFFF"></app-enfaf-icon>
        <div class="text">
          {{ noFilesText }}
        </div>
      </div>
    </div>
    }
  </div>
</div>

<input type="file" #fileInput style="display: none" [accept]="accept" (change)="onFileSelected($event)"
  [multiple]="acceptMultiple" />

<ng-template #fileItem let-file let-i="index" let-isCurrentFile="isCurrentFile">
  <div class="file-item" (click)="isCurrentFile ? previewCurrentFile(file) : previewFile(file)">
    <div class="file-preview">
      @if (isCurrentFile && utils.getFileIcon(file.filename.split('.').pop()) === 'file-image' || !isCurrentFile &&
      utils.getFileIcon(file.name.split('.').pop() || '') === 'file-image') {
      <img [src]="getImageSrc(file)" alt="file preview"
        [class]="(isCurrentFile ? file.filename : file.name).toLowerCase().endsWith('.svg') ? 'file-preview-image svg-preview' : 'file-preview-image'" />
      } @else if (isCurrentFile && utils.getFileIcon(file.filename.split('.').pop()) === 'file-video' || !isCurrentFile
      && utils.getFileIcon(file.name.split('.').pop() || '') === 'file-video') {
      <app-enfaf-icon svgIconName="file-video-dark" iconSize="24px"></app-enfaf-icon>
      } @else {
      <app-enfaf-icon svgIconName="file-dark" iconSize="24px"></app-enfaf-icon>
      }
    </div>
    <div class="file-name">
      <div>
        <span [title]="isCurrentFile ? file.filename : file.name">{{ isCurrentFile ? file.filename : file.name }}</span>
      </div>
    </div>
    <div class="file-actions">
      <div class="action-button delete"
        (click)="isCurrentFile ? confirmRemoveCurrentFile($event, file) : confirmRemoveFile($event, i)">
        <app-enfaf-icon svgIconName="trash-red" iconSize="18px" />
      </div>
    </div>
  </div>
</ng-template>
